const $ = jQuery;

const InputNumber = {
  var: {
    min: 0,
    max: null,
    step: 1,
  },
  dom: { inputs: $('input[type="number"]') },
  increase: ($input) => {
    const currentVal = parseFloat($input.val());
    const newValue = currentVal + InputNumber.var.step;

    if (
      (InputNumber.var.max != null && newValue <= InputNumber.var.max) ||
      InputNumber.var.max == null
    ) {
      $input.val(newValue);
      $input.trigger("change");
    }
  },
  decrease: ($input) => {
    const currentVal = parseFloat($input.val());
    const newValue = currentVal - InputNumber.var.step;

    if (InputNumber.var.min <= newValue) {
      $input.val(newValue);
      $input.trigger("change");
    }
  },
  makeDom: () => {
    for (
      let index = 0;
      index < $('.quantity input[type="number"]').length;
      index++
    ) {
      const $inputWrapper = $('<div class="input-wrapper" />');
      const $this = $($('input[type="number"]')[index]);

      let $plus, $minus;

      if ($this.closest(".shop-pages").length > 0) {
        $plus = $('<span class="arrow-up icon">+</span>');
        $minus = $('<span class="arrow-down icon">-</span>');
      } else {
        $plus = $(
          '<svg class="arrow-up" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.23466 4.71935C9.27523 4.75885 9.30748 4.80608 9.32949 4.85825L9.23736 4.89713L9.3295 4.85825C9.35151 4.91042 9.36286 4.96647 9.36286 5.02309C9.36286 5.07971 9.35151 5.13576 9.3295 5.18793L9.23736 5.14905C9.22054 5.18891 9.1959 5.225 9.1649 5.25518L9.23478 5.32671C9.23474 5.32675 9.2347 5.32679 9.23466 5.32683C9.15242 5.40711 9.04204 5.45205 8.92711 5.45205C8.81213 5.45205 8.7017 5.40707 8.61945 5.32671L8.58933 5.29729V5.29664L5.13106 1.92556L1.64268 5.326L1.5728 5.25447L1.6426 5.32608L1.64265 5.32603C1.5604 5.40636 1.44999 5.45134 1.33501 5.45134C1.22003 5.45134 1.1096 5.40635 1.02735 5.326L1.02724 5.3259C0.986956 5.28643 0.954952 5.23931 0.933103 5.18732C0.911254 5.13532 0.9 5.07949 0.9 5.02309C0.9 4.96669 0.911254 4.91086 0.933103 4.85886C0.954951 4.80687 0.986956 4.75975 1.02724 4.72028L1.02742 4.72011L4.81279 1.02943L4.8128 1.02942C4.89795 0.946419 5.01215 0.899967 5.13106 0.899967C5.24997 0.899967 5.36418 0.946419 5.44933 1.02942L5.44933 1.02942L9.23466 4.71935ZM9.23466 4.71935L9.1649 4.791L9.2347 4.71939L9.23466 4.71935Z" fill="#513933" stroke="#513933" stroke-width="0.2"/></svg>'
        );
        $minus = $(
          '<svg class="arrow-down" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.23466 1.6327C9.27523 1.5932 9.30748 1.54597 9.32949 1.4938L9.23736 1.45492L9.3295 1.4938C9.35151 1.44163 9.36286 1.38558 9.36286 1.32896C9.36286 1.27234 9.35151 1.21629 9.3295 1.16412L9.23736 1.203C9.22054 1.16314 9.1959 1.12705 9.1649 1.09687L9.23478 1.02534C9.23474 1.0253 9.2347 1.02526 9.23466 1.02522C9.15242 0.944942 9.04204 0.9 8.92711 0.9C8.81213 0.9 8.7017 0.944985 8.61945 1.02534L8.58933 1.05476V1.05541L5.13106 4.42649L1.64268 1.02605L1.5728 1.09758L1.6426 1.02597L1.64265 1.02602C1.5604 0.945687 1.44999 0.900712 1.33501 0.900712C1.22003 0.900712 1.1096 0.945697 1.02735 1.02605L1.02724 1.02615C0.986956 1.06562 0.954952 1.11274 0.933103 1.16473C0.911254 1.21673 0.9 1.27256 0.9 1.32896C0.9 1.38536 0.911254 1.44119 0.933103 1.49319C0.954951 1.54518 0.986956 1.5923 1.02724 1.63177L1.02742 1.63194L4.81279 5.32262L4.8128 5.32263C4.89795 5.40563 5.01215 5.45208 5.13106 5.45208C5.24997 5.45208 5.36418 5.40563 5.44933 5.32263L5.44933 5.32263L9.23466 1.6327ZM9.23466 1.6327L9.1649 1.56105L9.2347 1.63266L9.23466 1.6327Z" fill="#513933" stroke="#513933" stroke-width="0.2"/></svg>'
        );
      }

      if ($this.attr("min") && $this.attr("min") !== "")
        InputNumber.var.min = parseFloat($this.attr("min"));
      if ($this.attr("max") && $this.attr("max") !== "")
        InputNumber.var.max = parseFloat($this.attr("max"));
      if ($this.attr("step") && $this.attr("step") !== "")
        InputNumber.var.step = parseFloat($this.attr("step"));

      $this.wrapAll($inputWrapper);

      const $parent = $this.parent();

      $parent.append($plus);
      $parent.append($minus);

      $plus.on("click", () => {
        InputNumber.increase($this);
      });
      $minus.on("click", () => {
        InputNumber.decrease($this);
      });
    }
  },
  init: function () {
    InputNumber.makeDom();
    $("body").on("updated_wc_div", function () {
      InputNumber.makeDom();
    });
  },
};

export default InputNumber;
